

















import Vue, { PropType } from "vue";
import { MuniFeatureProperties } from "@/types";
import { mapState } from "vuex";
import { downloadMuniDataCsv } from "@/services/muniDataDownload";
import { fetchPollutantMeta, fetchGnfrMeta } from "@/services/meta";
import LoadingAnimation from "./LoadingAnimation.vue";

export default Vue.extend({
  props: {
    featProps: { type: Object as PropType<MuniFeatureProperties> }
  },
  computed: mapState(["lang"]),
  components: { LoadingAnimation },
  data() {
    return {
      loadingMuniData: false as boolean,
      lastAttemptFailed: false as boolean
    };
  },
  watch: {
    featProps() {
      this.lastAttemptFailed = false;
    }
  },
  methods: {
    getDownnloadMuniDataButton(): HTMLElement {
      return this.$refs["download-muni-data-button"] as HTMLElement;
    },
    translateOrDefault(key: string, defaultString: string): string {
      const translated = this.$options.filters
        ? this.$options.filters.translate(key)
        : defaultString;
      return translated !== key ? translated : defaultString;
    },
    async downloadMuniData() {
      this.loadingMuniData = true;
      const filenamePrefix = this.translateOrDefault(
        "csv-data-download.filename-prefix",
        "paastodata"
      );
      const headerRowPrefix = this.translateOrDefault(
        "csv-data-download.header-row-prefix",
        "kuntanro;nimi;namn;vuosi;luokka;"
      );
      const filenameSuffix = this.featProps.name[this.lang];

      const success = await downloadMuniDataCsv(
        filenamePrefix,
        filenameSuffix,
        headerRowPrefix,
        this.lang,
        fetchGnfrMeta,
        fetchPollutantMeta,
        this.featProps.id
      );

      this.loadingMuniData = false;
      this.lastAttemptFailed = !success;
      this.getDownnloadMuniDataButton().blur();
    }
  }
});
